module.exports = __webpack_public_path__ + "static/media/eraser.dcf65e0b.svg";